const Screencast = () => {
  // Convert Google Drive sharing URL to embed URL
  const videoId = "1BUtZ2IV1RQEyCJZd4FAtnX0Pr_NLHrjt";
  const embedUrl = `https://drive.google.com/file/d/${videoId}/preview`;

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="text-center mb-8">
        <h1 className="text-4xl font-bold mb-4">
          Product Demo
        </h1>
        <p className="text-lg text-muted-foreground">
          Watch our detailed walkthrough of the Reveshare platform
        </p>
      </div>

      <div 
        className="mx-auto max-w-3xl rounded-lg overflow-hidden shadow-xl bg-black"
        style={{
          position: "relative",
          paddingBottom: "42%", // Decreased height while maintaining aspect ratio
          height: 0,
          width: "75%" // Decreased width
        }}
      >
        <iframe
          src={embedUrl}
          allow="autoplay"
          allowFullScreen
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            border: 0
          }}
          title="ReveShare Platform Demo"
        />
      </div>

      <div className="mt-8 text-center max-w-2xl mx-auto">
        <p className="text-muted-foreground">
          This demonstration showcases the key features and functionality of our platform, helping you understand how to make the most of ReveShare.
        </p>
      </div>
    </div>
  );
};

export default Screencast;
